import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';
import './custom-label.scss';

function CustomLabel({ className, ...props }: ComponentProps<'span'>) {
  return <span className={cn('custom-label', className)} {...props} />;
}

export { CustomLabel };
